export const DEFAULT_FILTERS = [
    'MissingRow',
    'StartBalanceDifference',
    'FinalBalanceDifference',
    'TurnoverDifference',
    'DebitAndCreditDifference',
    'DatesDifference',
    'CauseDatesDifference',
    'NumbersDifference',
    'Refund',
    'Duplicate'
];
